import { Controller } from "@hotwired/stimulus"

// Formulário de Agendamentos de Jobs: mostra os campos do tipo de
// agendamento selecionado e, ao trocar o job, aplica os defaults e marca os
// obrigatórios lidos dos data-* serializados nas <option> (whitelist
// JOB_SCHEDULABLE_JOBS).
export default class extends Controller {
  static targets = ["tipo", "job", "parametros", "bloco"]

  connect() {
    this.atualizarVisibilidade()
  }

  tipoAlterado() {
    this.atualizarVisibilidade()
  }

  jobAlterado() {
    const option = this.jobTarget.options[this.jobTarget.selectedIndex]
    if (!option || !option.value) return

    this.aplicarDefaults(this.parseJson(option.dataset.defaults) || {})
    this.aplicarObrigatorios(this.parseJson(option.dataset.requiredAttributes) || [])
    this.aplicarParametrosObrigatorios(this.parseJson(option.dataset.requiredParams) || [])
    this.atualizarVisibilidade()
  }

  atualizarVisibilidade() {
    const tipo = this.tipoTarget.value

    this.blocoTargets.forEach((bloco) => {
      const tipos = (bloco.dataset.tipos || "").split(",")
      bloco.style.display = tipos.includes(tipo) ? "" : "none"
    })
  }

  aplicarDefaults(defaults) {
    for (const [campo, valor] of Object.entries(defaults)) {
      if (Array.isArray(valor)) {
        // Campos de múltipla seleção (ex.: dias_semana via checkboxes): o default
        // substitui a marcação anterior em vez de somar a ela
        this.element.querySelectorAll(`input[name="job_schedule[${campo}][]"]`).forEach((checkbox) => {
          checkbox.checked = false
        })
        valor.forEach((item) => {
          const checkbox = this.element.querySelector(`#dia_${item}`)
          if (checkbox) checkbox.checked = true
        })
        continue
      }

      const input = this.element.querySelector(`#job_schedule_${campo}`)
      if (input) input.value = valor
    }
  }

  aplicarObrigatorios(atributos) {
    const padraoNome = /job_schedule\[(.+?)\]/

    this.element.querySelectorAll("input, select, textarea").forEach((input) => {
      const nome = input.name.match(padraoNome)?.[1]
      if (!nome) return

      if (atributos.includes(nome)) {
        input.setAttribute("required", "required")
      } else {
        input.removeAttribute("required")
      }
    })
  }

  aplicarParametrosObrigatorios(parametros) {
    if (parametros.length > 0) {
      this.parametrosTarget.setAttribute("required", "required")

      const modelo = {}
      parametros.forEach((parametro) => {
        modelo[parametro] = `Valor para ${parametro}`
      })
      this.parametrosTarget.value = JSON.stringify(modelo, null, 2)
    } else {
      this.parametrosTarget.removeAttribute("required")
    }
  }

  parseJson(texto) {
    if (!texto) return null

    try {
      return JSON.parse(texto)
    } catch {
      return null
    }
  }
}
